import { render, staticRenderFns } from "./MortgagesTableBody.vue?vue&type=template&id=715899a2&scoped=true&"
import script from "./MortgagesTableBody.vue?vue&type=script&lang=ts&"
export * from "./MortgagesTableBody.vue?vue&type=script&lang=ts&"
import style0 from "./MortgagesTableBody.vue?vue&type=style&index=0&id=715899a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715899a2",
  null
  
)

export default component.exports